// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"594":"238ddf1f","636":"24b4db3b"}[chunkId] + ".js";
};